<template>
  <v-sheet
    background-color="transparent"
    width="100%"
    height="100%"
    class="list"
  >
    <v-sheet
      color="transparent"
      width="100%"
      class="
        white--text
        text-h5 text-sm-h4 text-md-h3 text-lg-h2
        font-weight-bold
        text-center
        pt-6 pt-md-8 pt-lg-12
      "
    >
      <Title>Produtos</Title>
    </v-sheet>

    <v-container class="pt-8 pb-10 pt-lg-12 pb-lg-16">
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" sm="6" md="7">
              <v-form @submit="search">
                <v-text-field
                  dense
                  outlined
                  name="q"
                  v-model="q"
                  label="Buscar Produto"
                  required
                  append-icon="fa-search"
                ></v-text-field>

                <v-btn type="submit" class="d-none"></v-btn>
              </v-form>
            </v-col>

            <v-col cols="12" sm="6" md="5">
              <v-select
                dense
                @change="changeCategory"
                outlined
                v-model="category"
                :items="[
                  ...[
                    {
                      text: 'Todos os Produtos',
                      value: '/produtos',
                    },
                  ],
                  ...filterCategories,
                ]"
                label="Selecionar Categoria"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <Loading v-if="loading" />

      <div v-else>
        <v-row v-if="items.length">
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-for="(item, key) in items"
            :key="key"
          >
            <ProductCard :item="item" />
          </v-col>

          <v-col cols="12">
            <v-pagination
              class="mt-10"
              v-model="page"
              :length="pagesLength"
              :total-visible="9"
              v-if="pagesLength > 1"
            ></v-pagination>
          </v-col>
        </v-row>

        <div v-else>
          <v-alert type="secondary" class="mt-5">
            <v-row align="center">
              <v-col class="grow">
                Nenhum conteúdo adicionado até o momento.
              </v-col>

              <v-col class="shrink py-0">
                <v-btn
                  color="primary"
                  :to="path"
                  height="auto"
                  class="
                    d-inline-flex
                    text-body-1
                    white--text
                    font-weight-bold
                    text-none
                    py-3
                    px-5
                  "
                  depressed
                  tile
                >
                  Todos os Produtos
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import ProductCard from "../../cards/Products.vue";
import { formatToURL } from "../../../utils/formatToURL";
import Title from "../../widgets/Title.vue";

const _config = {
  path: "/produtos",
  mod: "products",
};

export default {
  data: () => ({
    loading: true,
    items: [],
    path: _config.path,
    itemsPerPage: 24,
    totalItems: 0,
    q: "",
    category: "",
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    filterCategories() {
      return this.$rest("products-categories").list.map(({ title }) => ({
        text: title,
        value: `/produtos/${formatToURL(title)}`,
      }));
    },
    productsCategories() {
      return this.$rest("products-categories").list.map(({ id, title }) => ({
        id,
        title: title,
        uri: formatToURL(title),
      }));
    },
    filterCategory() {
      if (!this.$route.params.category) return "";

      return this.productsCategories.filter(
        (category) => category.uri === this.$route.params.category
      )[0];
    },
  },
  created() {
    this.get();
  },
  watch: {
    filterCategory() {
      this.get();
    },
    page() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  methods: {
    changeCategory() {
      if (this.$route.path != this.category) this.$router.push(this.category);
    },
    search(event) {
      event.preventDefault();
      const query = {};
      query.q = this.q;

      this.$router.push({ query });
    },
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.q) params.search = this.q;
      if (this.page) params.page = this.page;
      if (this.filterCategory) params.category = this.filterCategory.id;

      this.loading = true;

      console.log(params);

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(({ id, img, category, title }) => ({
              img,
              title,
              to: `${this.path}/${formatToURL(category.title)}/${formatToURL(
                title
              )}-${id}`,
            }));
            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    Loading,
    ProductCard,
    Title,
  },
};
</script>

<style lang="scss" scoped></style>
